import { WalletProviderE } from '@tacans/shared-marketplace-layer';
import { useMemo } from 'react';
import { useBlockChains, useWallets } from 'src/features/common/wallet/hooks/wallet.hooks';

export const useIsAlreadyConnectedWallet = (blockchain: WalletProviderE) => {
    const blockChains = useBlockChains();
    const wallets = useWallets();

    return useMemo<boolean>(() => {
        const blockChain = blockChains.find(({ name }) => name === blockchain);
        return !!blockChain && !!wallets.find((w) => w.blockchainId === blockChain.id);
    }, [blockChains, blockchain, wallets]);
};
